export enum SubscriptionPlanEnum {
  Free = 'free',
  Premium = 'premium',
}
